import { kmm } from './kmm';

export interface LogErrorEventParams {
  errorCode: string;
  logMessage: string;
}

export const logErrorEvent = async (params: LogErrorEventParams): Promise<void> => {
  const { errorCode, logMessage } = params;

  try {
    if (errorCode) {
      await kmm((repo) => repo.logErrorEventWithErrorCode(logMessage, errorCode), false);
    } else {
      await kmm((repo) => repo.logErrorEvent(logMessage), false);
    }
  } catch (error) {
    console.error('logErrorEvent failed:', error);
  }
};

export default logErrorEvent;
